module.exports = {
    type: 'object',
    additionalProperties: true,
    properties: {
        id: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        streetName: {
            type: 'string'
        },
        streetNumber: {
            type: 'string'
        },
        city: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        region: {
            type: 'string'
        },
        state: {
            type: 'string'
        },
        postalCode: {
            type: 'string'
        }
    }
};
